/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestHeartbeatIntervalSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AUTO_TEST_HEARTBEAT_INTERVAL')],
    ['value', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
]);
export class AutoTestHeartbeatIntervalSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestHeartbeatIntervalSettingParser.decode(input).map(res => new AutoTestHeartbeatIntervalSetting(res));
    }
    static unsafeDecode(input) {
        return AutoTestHeartbeatIntervalSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestHeartbeatIntervalSettingParser.encode(data);
    }
    static schema() {
        return AutoTestHeartbeatIntervalSettingParser.schema();
    }
}
